/* Adorn pincode V10. One controller, existing storage/events and delivery engine.
 * No postcode network API, automatic popup, fake availability or checkout writes.
 */
(() => {
  'use strict';
  const VERSION = '2026-10-03.10';
  if (window.AdornPincodePopup && window.AdornPincodePopup.version === VERSION) {
    window.AdornPincodePopup.refresh();
    return;
  }
  const root = document.getElementById('AdornMumbaiLocation');
  if (!root) return;
  const modal = root.querySelector('[data-adorn-location-modal]');
  const panel = root.querySelector('.adorn-location__dialog');
  const bar = root.querySelector('[data-adorn-location-bar]') || document.querySelector('[data-adorn-location-bar]');
  const input = root.querySelector('[data-adorn-location-input]');
  const form = root.querySelector('[data-adorn-location-form]');
  const message = root.querySelector('[data-adorn-location-message]');
  const formView = root.querySelector('[data-adorn-location-form-view]');
  const success = root.querySelector('[data-adorn-location-success]');
  if (!modal || !panel || !bar || !input || !form || !message || !formView || !success) return;
  window.__adornMumbaiExpressLocationV5 = true;
  const PIN = 'adorn_selected_pincode';
  const ZONE = 'adorn_selected_delivery_zone';
  const DISMISS = 'adorn_pincode_dismiss_until';
  const life = new AbortController();
  const signal = life.signal;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Map();
  const allowedPin = value => /^[1-9][0-9]{5}$/.test(String(value || '').trim());
  let selectedPin = '', opened = false, opener = null, scrollState = null;
  let focusFrame = 0, animationEpoch = 0, mapIdle = 0;
  const memory = new Map();
  const submit = root.querySelector('[data-adorn-location-submit]');
  const submitLabel = root.querySelector('[data-adorn-submit-label]');
  const current = bar.querySelector('[data-adorn-location-current]');
  const express = bar.querySelector('[data-adorn-location-express]');
  const successTitle = root.querySelector('[data-adorn-location-success-title]');
  const successCopy = root.querySelector('[data-adorn-location-success-copy]');
  const successBadge = root.querySelector('[data-adorn-location-success-badge]');
  const successPin = root.querySelector('[data-adorn-location-success-pin]');
  const expressCard = root.querySelector('[data-adorn-location-express-card]');
  const successClose = root.querySelector('[data-adorn-location-success-close]');
  function get(key) {
    if (memory.has(key)) return memory.get(key);
    try { const value = localStorage.getItem(key); if (value) return value; } catch (_) {}
    try {
      const prefix = encodeURIComponent(key) + '=';
      const item = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(prefix));
      if (item) return decodeURIComponent(item.slice(prefix.length));
    } catch (_) {}
    return '';
  }
  function set(key, value, days = 365) {
    memory.set(key, String(value));
    try { localStorage.setItem(key, String(value)); } catch (_) {}
    try {
      document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(String(value)) +
        '; path=/; max-age=' + Math.round(days * 86400) + '; SameSite=Lax' +
        (location.protocol === 'https:' ? '; Secure' : '');
    } catch (_) {}
  }
  function remove(key) {
    memory.set(key, '');
    try { localStorage.removeItem(key); } catch (_) {}
    try { document.cookie = encodeURIComponent(key) + '=; path=/; max-age=0; SameSite=Lax'; } catch (_) {}
  }
  function estimate(pin) {
    if (!allowedPin(pin)) return null;
    const engine = window.AdornDeliveryEngine;
    if (!engine || typeof engine.getEstimate !== 'function') return undefined;
    try { return engine.getEstimate(pin, 0); } catch (_) { return undefined; }
  }
  function mountBar() {
    const mounts = Array.from(document.querySelectorAll('[data-adorn-adv-location-mount]'));
    const mount = mounts.find(node => !node.closest('[hidden]') && node.getClientRects().length) || mounts[0];
    const parent = mount || root;
    if (bar.parentNode !== parent) parent.insertBefore(bar, parent === root ? modal : null);
    bar.hidden = false;
  }
  function publishContext(pin, result) {
    const eligible = Boolean(result && result.type === 'mumbai');
    const context = {
      pincode: pin, zone: eligible ? 'mumbai' : 'standard',
      isMumbaiExpress: eligible, shippingLabel: eligible ? '2-Day Shipping' : '',
      serviceable: Boolean(result)
    };
    window.AdornDeliveryContext = context;
    const html = document.documentElement;
    html.dataset.adornPincode = pin;
    html.dataset.adornDeliveryZone = context.zone;
    html.classList.toggle('adorn-mumbai-express', eligible);
    html.classList.toggle('adorn-has-saved-location', Boolean(pin));
    window.dispatchEvent(new CustomEvent('adorn:pincode-selected', { detail: context }));
  }
  function refresh() {
    if (!root.isConnected) return;
    mountBar();
    const result = estimate(selectedPin);
    const eligible = Boolean(result && result.type === 'mumbai');
    if (selectedPin && result !== undefined) set(ZONE, eligible ? 'mumbai' : 'standard');
    if (current) current.textContent = selectedPin || 'Enter pincode';
    if (express) express.hidden = !eligible;
    const label = bar.querySelector('.adorn-location__deliver-label');
    const change = bar.querySelector('.adorn-location__change');
    if (label) label.textContent = selectedPin ? 'Deliver to' : 'Delivery location';
    if (change) change.textContent = selectedPin ? 'Change' : 'Check';
    const trigger = bar.querySelector('[data-adorn-location-change]');
    if (trigger) trigger.setAttribute('aria-label', selectedPin ? 'Change delivery pincode ' + selectedPin : 'Enter pincode to check delivery');
    publishContext(selectedPin, result);
    scheduleMap();
  }
  function stopAnimation(key) {
    const state = animations.get(key);
    if (!state) return;
    state.dead = true;
    try { if (state.cleanup) state.cleanup(); else if (state.animation) state.animation.destroy(); } catch (_) {}
    if (state.container) state.container.replaceChildren();
    if (state.fallback) state.fallback.hidden = false;
    animations.delete(key);
  }
  function playAnimation(key, container, fallback, path, loop) {
    if (!container || animations.has(key) || reduced.matches || !window.AdornAssets) return;
    const state = { container, fallback, dead: false, epoch: animationEpoch, animation: null, cleanup: null };
    animations.set(key, state);
    if (fallback) fallback.hidden = false;
    Promise.resolve().then(() => window.AdornAssets.loadLottie()).then(lottie => {
      if (state.dead || !container.isConnected || reduced.matches ||
          (key === 'success' && (!opened || success.hidden || state.epoch !== animationEpoch))) return;
      const animation = lottie.loadAnimation({ container, renderer: 'svg', loop, autoplay: false, path,
        rendererSettings: { progressiveLoad: true, preserveAspectRatio: 'xMidYMid meet' } });
      state.animation = animation;
      state.cleanup = window.AdornAssets.watchAnimation(container, animation, true);
      animation.addEventListener('DOMLoaded', () => { if (!state.dead && fallback) fallback.hidden = true; });
      animation.addEventListener('data_failed', () => stopAnimation(key));
    }).catch(() => stopAnimation(key));
  }
  function scheduleMap() {
    if (animations.has('map') || mapIdle || reduced.matches) return;
    const run = () => {
      mapIdle = 0;
      if (!bar.isConnected || bar.hidden) return;
      playAnimation('map', bar.querySelector('[data-adorn-header-location-lottie]'),
        bar.querySelector('[data-adorn-header-location-fallback]'),
        'https://cdn.shopify.com/s/files/1/0268/7051/3742/files/Map_Location_Pointer.json?v=1789037742', true);
    };
    mapIdle = window.requestIdleCallback ? requestIdleCallback(run, { timeout: 3000 }) : setTimeout(run, 1000);
  }
  function setMessage(text = '') {
    message.textContent = text;
    message.classList.toggle('is-error', Boolean(text));
    input.setAttribute('aria-invalid', String(Boolean(text)));
  }
  function resetView() {
    animationEpoch += 1;
    stopAnimation('success');
    formView.hidden = false;
    success.hidden = true;
    success.classList.remove('is-express');
    if (expressCard) expressCard.hidden = true;
    if (submit) submit.disabled = false;
    if (submitLabel) submitLabel.textContent = 'Check Delivery';
    form.removeAttribute('aria-busy');
    modal.setAttribute('aria-labelledby', 'AdornLocationTitle');
    setMessage();
  }
  function viewport() {
    if (!opened) return;
    const view = window.visualViewport;
    modal.style.setProperty('--adorn-pincode-vh', (view ? view.height : innerHeight) + 'px');
    modal.style.setProperty('--adorn-pincode-top', (view ? view.offsetTop : 0) + 'px');
  }
  function focus(element) {
    if (element && element.isConnected) { try { element.focus({ preventScroll: true }); } catch (_) { element.focus(); } }
  }
  function open(trigger) {
    if (!root.isConnected) return;
    mountBar();
    if (opened) { focus(success.hidden ? input : successClose); return; }
    opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
    resetView();
    input.value = selectedPin;
    modal.hidden = false;
    opened = true;
    scrollState = {
      htmlOverflow: document.documentElement.style.getPropertyValue('overflow'),
      htmlPriority: document.documentElement.style.getPropertyPriority('overflow'),
      bodyOverflow: document.body.style.getPropertyValue('overflow'),
      bodyPriority: document.body.style.getPropertyPriority('overflow')
    };
    document.documentElement.style.setProperty('overflow', 'hidden');
    document.body.style.setProperty('overflow', 'hidden');
    document.body.classList.add('adorn-location-open');
    try { if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', ''); }
    catch (_) { modal.setAttribute('open', ''); }
    viewport();
    focusFrame = requestAnimationFrame(() => {
      if (!opened) return;
      panel.scrollTop = 0;
      focus(success.hidden ? input : successClose);
      if (success.hidden && input.value) input.select();
    });
  }
  function close(restoreFocus = true) {
    if (!opened) return;
    opened = false;
    cancelAnimationFrame(focusFrame);
    if (modal.open && typeof modal.close === 'function') modal.close();
    modal.removeAttribute('open');
    modal.hidden = true;
    document.body.classList.remove('adorn-location-open');
    if (scrollState) {
      document.documentElement.style.setProperty('overflow', scrollState.htmlOverflow, scrollState.htmlPriority);
      document.body.style.setProperty('overflow', scrollState.bodyOverflow, scrollState.bodyPriority);
      scrollState = null;
    }
    resetView();
    if (restoreFocus) {
      const destination = opener && opener.isConnected && opener !== document.body ? opener : bar.querySelector('[data-adorn-location-change]');
      focus(destination);
    }
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    event.stopPropagation();
    if (!opened || (submit && submit.disabled)) return;
    const pin = input.value.trim();
    if (!allowedPin(pin)) { setMessage('Please enter a valid 6-digit pincode, not starting with 0.'); focus(input); return; }
    const result = estimate(pin);
    if (result === undefined) { setMessage('Delivery check is temporarily unavailable. Please reload the page and try again.'); return; }
    if (!result) { setMessage('No delivery estimate is available for this pincode. Check another pincode or contact support.'); focus(input); return; }
    if (submit) submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    const eligible = result.type === 'mumbai';
    // Persist BEFORE broadcasting so every listener reads the same pincode.
    selectedPin = pin;
    set(PIN, pin);
    set(ZONE, eligible ? 'mumbai' : 'standard');
    remove(DISMISS);
    refresh();
    form.removeAttribute('aria-busy');
    formView.hidden = true;
    success.hidden = false;
    success.classList.toggle('is-express', eligible);
    if (successPin) successPin.textContent = pin;
    if (successBadge) successBadge.textContent = eligible ? '⚡ Mumbai Express unlocked' : '✓ Delivery area confirmed';
    if (successTitle) successTitle.textContent = eligible ? 'Fast delivery is available' : 'Pincode saved';
    if (successCopy) successCopy.textContent = eligible ?
      'Your pincode qualifies for our Mumbai Express delivery option.' :
      'Delivery is available in your area. See each product for its estimated delivery date.';
    if (expressCard) expressCard.hidden = !eligible;
    modal.setAttribute('aria-labelledby', 'AdornLocationSuccessTitle');
    panel.scrollTop = 0;
    focus(successClose || successTitle);
    playAnimation('success', root.querySelector('[data-adorn-location-success-animation]'),
      root.querySelector('[data-adorn-location-success-fallback]'),
      'https://cdn.shopify.com/s/files/1/0268/7051/3742/files/Success.json?v=1788935684', false);
  }, { signal });
  input.addEventListener('input', () => { input.value = input.value.replace(/\D/g, '').slice(0, 6); setMessage(); }, { signal });
  modal.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target === modal || event.target.closest('[data-adorn-location-close], [data-adorn-location-success-close], [data-adorn-location-browse]')) {
      event.preventDefault(); event.stopPropagation();
      if (event.target.closest('[data-adorn-location-browse]')) set(DISMISS, Date.now() + 86400000, 2);
      close();
    }
  }, { signal });
  modal.addEventListener('cancel', event => { event.preventDefault(); close(); }, { signal });
  modal.addEventListener('close', () => { if (opened && !modal.open) close(); }, { signal });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-adorn-location-change], [data-na-delivery-tag]');
    if (!trigger) return;
    event.preventDefault(); event.stopPropagation(); open(trigger);
  }, { capture: true, signal });
  document.addEventListener('keydown', event => {
    if (!opened) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(modal.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href],[tabindex="0"]'))
      .filter(node => node.tabIndex >= 0 && !node.closest('[hidden]') && node.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) { event.preventDefault(); focus(panel); return; }
    if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { event.preventDefault(); focus(last); }
    else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) { event.preventDefault(); focus(first); }
  }, { capture: true, signal });
  window.addEventListener('adorn:open-pincode-selector', event => open(event.detail && event.detail.trigger), { signal });
  document.addEventListener('shopify:section:unload', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.contains(bar)) {
      stopAnimation('map');
      root.insertBefore(bar, modal); // preserve the SAME live bar and handlers across header replacement
    }
  }, { capture: true, signal });
  document.addEventListener('shopify:section:load', () => refresh(), { signal });
  window.addEventListener('storage', event => {
    if (event.key !== PIN && event.key !== null) return;
    memory.delete(PIN); memory.delete(ZONE);
    const value = event.key === PIN ? event.newValue || '' : '';
    selectedPin = allowedPin(value) ? value.trim() : '';
    if (!selectedPin) { remove(PIN); remove(ZONE); }
    refresh();
  }, { signal });
  window.addEventListener('pageshow', () => { refresh(); if (opened) viewport(); }, { signal });
  window.addEventListener('pagehide', () => close(false), { signal });
  window.addEventListener('resize', viewport, { passive: true, signal });
  if (window.visualViewport) {
    visualViewport.addEventListener('resize', viewport, { passive: true, signal });
    visualViewport.addEventListener('scroll', viewport, { passive: true, signal });
  }
  if (reduced.addEventListener) reduced.addEventListener('change', () => {
    if (reduced.matches) { stopAnimation('map'); stopAnimation('success'); } else scheduleMap();
  }, { signal });
  const saved = get(PIN);
  selectedPin = allowedPin(saved) ? saved.trim() : '';
  window.AdornPincodePopup = { version: VERSION, open, close, refresh };
  refresh();
})();
